<template>
  <div class="app-social">
    <div class="app-social__share">
      <div
        class="fb-like"
        data-href="https://typenconquer.io"
        data-layout="button_count"
        data-action="like"
        data-size="small"
        data-show-faces="true"
        data-share="true"
      />

      <a
        href="https://twitter.com/typenconquerio?ref_src=twsrc%5Etfw"
        class="twitter-follow-button"
        data-show-count="false"
        >Follow @typenconquerio</a
      >
    </div>

    Find us at:
    <div class="app-social__icons">
      <a
        href="https://discord.gg/yCfkUr8"
        class="app-social__icon discord-color"
        target="_blank"
      >
        <i class="socicon-discord" /><span class="text">discord</span></a
      >
      <a
        href="https://twitter.com/typenconquerio"
        class="app-social__icon twitter-color"
        target="_blank"
      >
        <i class="socicon-twitter" /><span class="text">twitter</span></a
      >
      <a
        href="https://www.instagram.com/typenconquerio"
        class="app-social__icon instagram-color"
        target="_blank"
      >
        <i class="socicon-instagram" /><span class="text">Instagram</span></a
      >
      <a
        href="https://www.youtube.com/channel/UCZ3XG2UCe_AMG49TofBBO6A?sub_confirmation=1"
        class="app-social__icon youtube-color"
        target="_blank"
        ><i class="socicon-youtube" /><span class="text">Youtube</span></a
      >
    </div>
  </div>
</template>
<script>
export default {
  name: 'AppSocial',
  // components: { IcoFacebook, IcoDiscord, IcoTwitter, IcoInstagram, IcoYoutube },
  mounted () {
    window.twttr && window.twttr.widgets.load()
    window.FB && window.FB.XFBML.parse()
  },
  methods: {
    // Store in a var to choose the avatar
    close (network, url) {}
  }
}
</script>
<style>
.app-social {
  display: flex;
  flex-flow: column;
  align-items: center;
}

.app-social__share {
  display: flex;
  justify-content: center;
  margin: 4px;
  margin-top: -2px;
}

.app-social__icons {
  display: flex;
  flex-flow: rows;
}

.app-social__icon {
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: center;
  height: 40px;
  text-decoration: none;
}

.app-social__icon .text {
  display: none;
}

.app-social__icon i {
  cursor: pointer;
  margin: 4px 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  width: 33px;
  height: 33px;
  padding: 8px;
  border-radius: 100px;
  box-shadow: 0 0 1px 1px #eee;
  transition: all 0.9s;
}

.app-social__icon.discord-color {
  color: var(--social-discord);
}

.app-social__icon.twitter-color {
  color: var(--social-twitter);
}

.app-social__icon.instagram-color {
  color: var(--social-instagram);
}

.app-social__icon.youtube-color {
  color: var(--social-youtube);
}

.app-social__icon:not(:hover) i {
  color: #fff;
}
</style>
